export default __webpack_public_path__ + "static/media/rolling-bomb.f70d9260.png";